<template>
<div>
<div v-if="mode ==='full'" style="width: 866px;" class="container">
  <div v-if="years || true" style="display: flex; justify-content: center;" class="form-row align-items-center">
    <div class="selection-item">
      <div style="font-weight: bold;">Year</div>
      <select style="width: 150px;" class="custom-select"   :disabled="getYearCompletedStatus" text="Select Year" v-model="selectedYear" @change="selectYear">
        <option value="">Select Year</option>
        <option v-for="(year,index) in years" :value="index" :key="index">{{ year.label }}</option>
      </select>
    </div>
    <div v-if="getYearCompletedStatus">
       <img style="margin-top: 20px; margin-right: 20px" src="../assets/img/ajax-loader.gif" alt="loading data..." />
    </div>
    <div class="selection-item">
      <div style="font-weight: bold;">Program</div>
      <!--<vue-autosuggest 
        ref="autosuggest"
        @click="clickHandler"
        @keydown.tab.prevent="tabHandler"
        @selected="selectHandler"
        :suggestions="filteredSuggestions"
        :inputProps="inputProps"
        @input="fetchResults"
        :getSuggestionValue="getSuggestionValue"
      >
        <template slot-scope="{ suggestion }">
          <div>
            <b>{{suggestion.item}}</b>
          </div>
        </template>
      </vue-autosuggest>
      -->
      <select style="width: 300px;" :disabled="selectedYear.toString().length === 0" class="custom-select mr-sm-2" text="Select Program" v-model="selectedOption">
        <option value="">Select Program</option>
        <option v-for="option in (years[selectedYear] || {}).options" :key="option">{{ option }}</option>
      </select>
    </div>
    <div class="">
      <button style="width: 280px; margin-top: 20px;" type="button" class="btn btn-warning-arp" @click="submitSelection">Submit</button>
    </div>
    <!-- <p v-if="selectedOption">
      You selected a {{ years[selectedYear].label }} and specifically {{ selectedOption }}.
    </p> -->
  </div>
</div>
   <div v-if="mode === 'widget' && showModal">
     <div class="modal-main">
       <div id="modalBody" :style="{top: '100px', left: '60px'}" class="modal-content">
          <div v-if="true || years" class="selection-widget">
            <div class="flex-default">
             <div style="font-size: 20px; font-weight: bold;">Modify</div>
             <div style="margin-left: 20px;" class="close" @click="closeMetricEdit">&times;</div>
            </div>
            <div class="flex-default" style="flex-direction: column; width: 160px;font-weight: bold !important;">
            <div>Year</div> 
              <select class="form-control" :disabled="!years" text="Select Year"  v-model="selectedYear" @change="selectYear">
                <option value="">Select Year</option>
                <option v-for="(year,index) in years" :value="index" :key="index">{{ year.label }}</option>
              </select>
            </div>
            <div v-if="!years">
             <img style="margin-top:-70px; margin-left: 180px; width:26px;" src="../assets/img/ajax-loader.gif" alt="loading data..." />
                 </div>
            <div class="flex-default" style="flex-direction: column;font-weight: bold !important;">
              <div>Program Name</div>
              <select class="form-control" :disabled="!years" text="Select Program" v-model="selectedOption" v-if="selectedYear != -1">
                <option value="">Select Program</option>
                <option v-for="option in (years[selectedYear] || {}).options" :key="option">{{ option }}</option>
              </select>
            </div>
            <div class="" style="align-self: flex-end;">
              <button type="button" class="btn btn-warning-arp" @click="submitSelection">Show Metrics</button>
            </div>
          </div>
       </div>
     </div>
    </div>
    </div>
</template>

<script>

import { mapActions ,mapGetters} from 'vuex';
// import { VueAutosuggest } from "vue-autosuggest";
import Vue from 'vue';

export default {
  name: "ProgramSelection",
  components: {
    // VueAutosuggest
  },
  props: ['mode', 'hasChanges', 'yearSelection'],
  computed: mapGetters(['currentProgram','currentYear','currentYearIndex','currentProgramSelectionMenu', 'getYearCompletedStatus']),
  data: () => {
      return {
        years:false,
        selectedYear:'',
        selectedOption:'',
        showModal: true,
        suggestions: [],
        filteredSuggestions: [],
        selected: '',
				inputProps: {
          id:'autosuggest__input',
          // onInputChange: this.fetchResults,
					placeholder:'Select Program',
					class:'ddd'
				}
      }
    },
    methods: {
      ...mapActions(['updateParams','getMenuOptions', 'updateOverlayParams']),
      closeMetricEdit() {
        this.$emit('closeWidget');
      },
      onValidate: function($event){
          console.log(this.model.year, this.model.program)
          this.updateParams(this.model);
          this.$emit('paramsChange');
      },
      submitSelection: function(e){
        if(this.selectedOption === "" || this.selectedYear === "") {
          Vue.notify({
             group: 'error',
             text: 'Please select a year and program name.',
             closeOnClick:true
          })
          return;
        }
        var model = {}
        model['year'] = this.years[this.selectedYear].label
        model['program'] = this.selectedOption
        model['yearIndex'] = this.selectedYear
        console.log(model)
        const _this = this;
        if (this.hasChanges) {
          this.updateOverlayParams({
                            display: 'block',
                            title: 'Leaving Metrics',
                            message: 'All the changes will be lost. Are you sure you want to leave without saving?',
                            // specialClassNames: 'download-in-progress',
                            isNotification: false,
                            buttons: {
                                type: 'discard-challenge',
                                successHandler: () => {
                                  _this.updateParams(model)
                                  _this.$emit('paramsChange');
                                  setTimeout(() => {
                                    if (e && _this.mode === "widget") {
                                      _this.closeMetricEdit();
                                    }
                                  }, 500);
                                }
                            },
                            specialClassNames: 'delete-comment',
                            duration: '',
                            displayCloseIcon: true,
                            background: true
                        });
        } else {
            _this.updateParams(model)
                                  _this.$emit('paramsChange');
                                  setTimeout(() => {
                                    if (e && _this.mode === "widget") {
                                      _this.closeMetricEdit();
                                    }
                                  }, 500);
                                
        }
      },
      fetchResults(text) {
        this.filteredSuggestions = [{data:this.suggestions.filter(e => {
            return e.toLowerCase().indexOf(text.toLowerCase()) > -1;
          })
        }];
			},
      selectHandler(item){
        if (item){
          this.selected = item.item;
          this.selectedOption = item.item;
        }
      },
      tabHandler() {
        const { listeners, setCurrentIndex, setChangeItem, getItemByIndex } = this.$refs.autosuggest
        setCurrentIndex(0)
        setChangeItem(getItemByIndex(this.$refs.autosuggest.currentIndex), true)
        this.$refs.autosuggest.loading = true
        listeners.selected(true)
      },
      clickHandler(item){
        this.loading=false
        this.fetchResults(item ? item.item : "");
      },
      getSuggestionValue(suggestion) {
        return suggestion.item;
      },
      selectYear:function() {
      this.selectedOption = '';
    }
  },
  created() {
    window.ww = this;
    if (this.mode == "full") {
      this.getMenuOptions();
    } else {
      if (this.currentProgramSelectionMenu && this.currentProgramSelectionMenu.length > 0) {
        this.years = this.currentProgramSelectionMenu;
        this.years.forEach((element, index) => {
          if (element.label === this.yearSelection.toString()) {
            this.selectedYear = index;
          }
        });
      } else {
        this.getMenuOptions();
      }
    }

  },
  watch: {
    currentProgramSelectionMenu(){
      this.selectedYear = ''
      this.selectedOption = ''
      console.log(this.years)
      this.years = this.currentProgramSelectionMenu;
      console.log(this.years)
      
      console.log(`Current year index: ${this.currentYearIndex}  program: ${this.currentProgram}`)
      // this.submitSelection()
    },
    selectedYear() {
      this.suggestions = (this.years[this.selectedYear] || {}).options
    }
  } 
}
</script>
<style scoped>
.selection-item {
    display: flex;
    flex-direction: column;
    padding-right: 20px;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;
    width: 120px;
    height: 40px;
    padding: 8px;
}
.flex-default {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.selection-widget {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 225px;
  width: 100%
}
.modal-main {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 325px;
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.close {
  color: #aaaaaa;
  float: right;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style>
    #autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      padding: 10px;
      width: 100%;
      height: 38px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 10px;
      margin: 0;
      max-height: 190px;
      overflow: auto;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #F6F6F6;
    }
</style>
